import { SectionHeading } from "../home/CtaButtons";
import { RichText } from "./RichText";
import { ICONS } from "./icons";

export const ProductIntro = ({ intro, features }) => (
  <section id="overzicht" aria-labelledby="overzicht-title" className="section scroll-mt-12" data-testid="product-intro">
    <div className="container-tight grid gap-10 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <SectionHeading id="overzicht-title" eyebrow="Overzicht" title={intro.title} />
        {intro.text.map((t) => <p key={t.slice(0, 24)} className="mt-5 leading-relaxed text-slate-600"><RichText text={t} /></p>)}
      </div>
      <ul className="grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:col-span-7 lg:pt-2" data-testid="product-features">
        {features.map((f) => {
          const Icon = ICONS[f.icon] || ICONS.Sparkles;
          return (
            <li key={f.title} className="flex gap-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maas-soft text-maas"><Icon className="h-5 w-5" aria-hidden="true" /></span>
              <div>
                <h3 className="text-[17px] font-semibold text-ink">{f.title}</h3>
                <p className="mt-1.5 text-[14.5px] leading-relaxed text-slate-600">{f.text}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);

